import { render } from "./DayViewWorkAreaGridTaskBar.vue?vue&type=template&id=6c023fb5"
import script from "./DayViewWorkAreaGridTaskBar.vue?vue&type=script&lang=ts"
export * from "./DayViewWorkAreaGridTaskBar.vue?vue&type=script&lang=ts"
script.render = render

export default script